import type { ComponentProps } from 'react';
import { OwcProgressSpinner } from '@one/react';

export type PocProgressSpinnerProps = ComponentProps<typeof OwcProgressSpinner>;

export const PocProgressSpinner: React.FC<PocProgressSpinnerProps> = (props) => <OwcProgressSpinner {...props} />;
